import { feedbackEventBus } from "./feedbackEventBus"
import type { FeedbackOpenContext } from "./types"

export function openFeedbackDialog(context: FeedbackOpenContext = {}): void {
  feedbackEventBus.emit("open", context)
}
